import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';

class BtnWrapper extends PureComponent {
  handleTouchEvent = event => {
    event.stopPropagation();
    switch (event.type) {
      case 'touchstart':
        this.originColor = [];
        this.startX = event.changedTouches[0].pageX;
        this.startY = event.changedTouches[0].pageY;
        this.props.bgColor.forEach(item => {
          let itemStyle = Object.keys(item)[0];
          this.originColor.push({
            [`${itemStyle}`]: this.color.style[`${itemStyle}`],
          });
          this.color.style[`${itemStyle}`] = item[itemStyle];
        });
        break;
      case 'touchend':
        this.originColor.forEach(item => {
          let itemStyle = Object.keys(item)[0];
          this.originColor.push({
            [`${itemStyle}`]: this.color.style[`${itemStyle}`],
          });
          this.color.style[`${itemStyle}`] = item[itemStyle];
        });
        break;
      default:
        break;
    }
  };

  render() {
    return React.cloneElement(this.props.children, {
      ref: color => (this.color = color),
      onTouchStart: this.handleTouchEvent,
      onTouchMove: this.handleTouchEvent,
      onTouchEnd: this.handleTouchEvent,
    });
  }
}

BtnWrapper.PropTypes = {
  bgColor: PropTypes.array,
  children: PropTypes.element.isRequired,
};

export default BtnWrapper;



// WEBPACK FOOTER //
// ./src/components/BtnWrapper/index.js